import { AlphaCCircleIcon } from './AlphaCCircleIcon';

/**
 * author: Contributors
 * id 19229F43-9ACD-477E-9A30-9D2731080026
 * name alpha-c-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-c-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterCCircleIcon = AlphaCCircleIcon;
export default LetterCCircleIcon